<template>
  <div v-show="shareDialogVisible" class="mask" @click="cancelClick">
    <div class="content" id="content">
      <div class="content-body" v-if="!imgURL" id="content-body">
        <div class="header flex-between-center">
          <div class="user flex-start-center" v-if="userInfo.userName">
            <img :src="userInfo.headPortrait ? userInfo.headPortrait + parametersHead : headImg" class="head" alt="头像">
            <div class="user-info flex-center-start">
              <p class="name">{{ userInfo.userName }}</p>
              <p class="dis">给你分享了一个藏品</p>
            </div>
          </div>
          <div class="no-user" v-else>
            <span>NVWA丨数字藏品</span>
          </div>
          <div class="logo">
            <img src="https://image.nvwanft.cc/QmNRbLno4AT5Phc9MWSR792VxZU9F4f44xHKN9AnHhPWxC.ico" alt="">
          </div>
        </div>
        <div class="body">
          <img :src="info.coverPicture ? info.coverPicture.parameters : info.picture.parameters" class="good" alt="图片">
          <p class="name flex-start-center">{{ info.boxName }}
            <el-tooltip class="" effect="dark" content="官方已认证" placement="top">
              <div>
                <img v-if="info.addV == 1" src="@/assets/images/icon/v-icon.png" class="v-icon" alt="v">
              </div>
            </el-tooltip>
          </p>
          <p class="user">创作者：{{ info.nickName }}</p>
        </div>
        <div class="footer flex-between-center">
          <div class="left">
            <!-- <p>藏品编号：#1/5</p> -->
            <p class="flex-start-center">网络平台： <img src="../../assets/images/cun-logo.png" alt="CUN"> CUN</p>

            <p class="flex-start-center">铸造平台: 女娲NVWA</p>
            <p class="flex-start-center">存储： IPFS</p>
            <!-- <p>
            链上标识：jksjdfksjdkf
          </p> -->
          </div>
          <div class="right">
            <div id="qrCodeImg" style="display:none" ref="qrCodeDivImg"></div>
            <div class="qrCodeDiv" id="qrCodeDiv" ref="qrCodeDiv">

            </div>
          </div>
        </div>
      </div>
      <div class="img" v-else id="content-img">
        <img :src="imgURL" alt="">
        <div class="remind">
          <span>长按保存图片</span>
        </div>
      </div>

      <div class="cancel" @click.stop="cancelClick">
        <img src="../../assets/images/icon/delete-icon.png" alt="退出">
      </div>
      <div class="save" @click.stop="saveImagePc">
        保存图片
      </div>
    </div>

  </div>
</template>

<script>
import headImg from '../../assets/images/head.png'
import QRCode from 'qrcodejs2'
import html2canvas from 'html2canvas'
import { encode, ossParameters, ossParameters1 } from '../../assets/js/globle.js'
export default {
  props: ['shareDialogVisible', 'info'],
  data() {
    return {
      headImg: headImg,
      parameters: ossParameters(),
      parametersHead: ossParameters1(),
      imgURL: '',
      userInfo: {

      }
    }
  },
  watch: {
    'shareDialogVisible': {
      handler(val) {
        if (val) {
          this.qrcodeInit()
        }
      },
      deeply: true
    }
  },
  mounted() {
    // setTimeout(() => {
    this.init()
    // }, 1000)
  },
  methods: {
    init() {
      let userVO = localStorage.getItem('userVO')
      if (userVO) {
        this.userInfo = JSON.parse(userVO)
      } else {

      }
      // 处理邀请关系
      this.inviteDataFuc()
      console.log(this.info)
    },
    inviteDataFuc() {
      if (this.$route.query.inviteCode) {
        let data = {
          type: 'work',
          // nftId: this.$route.query.nftId,
          // nftNo: this.info.nftNumberVO.nftNo,
          inviteCode: this.$route.query.inviteCode
        }
        sessionStorage.setItem('inviteData', JSON.stringify(data))
      }
      console.log(sessionStorage.getItem('inviteData'))
    },
    cancelClick() {
      this.$emit('changeShareDialogVisible', false)
      let qrCodeDiv = document.getElementById('qrCodeDiv')
      if (qrCodeDiv) {
        qrCodeDiv.innerHTML = ''
      }
    },
    qrcodeInit() {
      let qrCodeImg = document.getElementById('qrCodeImg')
      let qrCodeDiv = document.getElementById('qrCodeDiv')
      qrCodeDiv.innerHTML = ''
      qrCodeImg.innerHTML = ''
      let userVO = localStorage.getItem('userVO')
      let inviteCode = ''
      if (userVO) {
        inviteCode = JSON.parse(userVO).inviteCode
      } else {

      }
      let text = location.origin + '/mysteryBoxInfo?info='
      let query = {
        boxUserId: this.info.boxUserId,
        boxId: this.info.boxId,
        inviteCode: inviteCode
      }

      text += encode(JSON.stringify(query))
      console.log(text)
      let qrcode = new QRCode(this.$refs.qrCodeDiv, {
        text: text,
        width: document.body.clientWidth > 768 ? 160 : 160,
        height: document.body.clientWidth > 768 ? 160 : 160,
        colorDark: '#333333', // 二维码颜色
        colorLight: '#ffffff', // 二维码背景色
        correctLevel: QRCode.CorrectLevel.H// 容错率，L/M/H
      })
      // console.log(qrcode)
      var myCanvas = document.getElementsByTagName('canvas')[0]
      var img = this.canvasToImage(myCanvas)
      myCanvas.style.width = '80px'
      myCanvas.style.height = '80px'
      img.style.width = '80px'
      img.style.height = '80px'
      qrCodeImg.append(img)
      // myCanvas.style.display = 'none'
      setTimeout(() => {
        this.saveImage()
      }, 500)

      // qrCodeImg.append(img)
    },
    // 保存图片
    saveImage() {
      var content = document.getElementById('content-body')
      const options = { useCORS: true, backgroundColor: null, dpi: 300 }
      window.pageYoffset = 0

      document.documentElement.scrollTop = 0

      document.body.scrollTop = 0
      console.log(content)
      html2canvas(content, options).then(
        canvas => {
          // const link = document.createElement('a')
          // link.href = canvas.toDataURL()
          // link.setAttribute('download', 'asdfasdf' + '.png')
          // link.style.display = 'none'
          // document.body.appendChild(link)
          // link.click()
          // document.body.appendChild(canvas);
          // 关闭锯齿
          var context = canvas.getContext('2d')
          context.mozImageSmoothingEnabled = false
          context.webkitImageSmoothingEnabled = false
          context.msImageSmoothingEnabled = false
          context.imageSmoothingEnabled = false
          console.log(canvas)
          this.imgURL = canvas.toDataURL('image/png')
          // 必须同源（访问的网站域名与服务器域名一致）才能下载
          // const eleLink = document.createElement('img')
          // eleLink.src = this.imgURL // 转换后的图片地址
          // eleLink.download = +new Date() + '_分享海报'
          // eleLink.setAttribute('download', new Date().getTime() + '_分享海报' + '.png')
          // document.body.appendChild(eleLink)
          // 触发点击
          // eleLink.click()
          // document.body.removeChild(eleLink)
          // 然后移除
          // this.$router.go(-1)
        }
      )
      // var img = this.canvasToImage(myCanvas)
      // var aLink = document.createElement('a')
      // aLink.download = this.teacherField.Te_Name + "分享";
      // aLink.href = ;
      // aLink.click()
    },
    saveImagePc() {
      var content = document.getElementById('content-img')
      const options = { useCORS: true, backgroundColor: null }
      window.pageYoffset = 0

      document.documentElement.scrollTop = 0

      document.body.scrollTop = 0
      html2canvas(content, options).then(
        canvas => {
          // const link = document.createElement('a')
          // link.href = canvas.toDataURL()
          // link.setAttribute('download', this.qrCodeTitle + '.png')
          // link.style.display = 'none'
          // document.body.appendChild(link)
          // link.click()
          // document.body.appendChild(canvas);
          this.imgURL = canvas.toDataURL('image/png')
          // 必须同源（访问的网站域名与服务器域名一致）才能下载
          const eleLink = document.createElement('a')
          eleLink.href = this.imgURL // 转换后的图片地址
          // eleLink.download = +new Date() + '_分享海报'
          eleLink.setAttribute('download', new Date().getTime() + '_分享海报' + '.png')
          document.body.appendChild(eleLink)
          // 触发点击
          eleLink.click()
          document.body.removeChild(eleLink)
          // 然后移除
          // this.$router.go(-1)
        }
      )
      // var img = this.canvasToImage(myCanvas)
      // var aLink = document.createElement('a')
      // aLink.download = this.teacherField.Te_Name + "分享";
      // aLink.href = ;
      // aLink.click()
    },
    canvasToImage(canvas) {
      let image = new Image()
      image.src = canvas.toDataURL('image/png')
      return image
    }
  }
}
</script>

<style lang="scss" scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100%;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.5);
}

.content {
  position: relative;
  z-index: 1;
  height: auto;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  font-variant: normal;
  font-family: 'Microsoft Yahei';

  flex-direction: column;

  .content-body {
    width: 428px;
    height: 800px;
    background: #FFFFFF;
    border-radius: 4px;
    margin: 18px auto;
    padding: 20px 24px;

    background: #FFFFFF;

    // border-radius: 4px;
    // margin: 38px auto;
    // padding: 20px 24px;
    @media screen and(max-width:768px) {
      width: 295px;
      height: 580px;
      padding: 20px 24px;

    }

    .header {
      .user {
        .head {
          width: 44px;
          height: 44px;
          border: 1px solid #F0F0F0;
          margin-right: 8px;
          border-radius: 50%;

          @media screen and(max-width:768px) {
            width: 34px;
            height: 34px;
          }
        }

        .user-info {
          flex-direction: column;
          height: 44px;

          .name {
            font-size: 15px;
            font-weight: 500;
            color: #373737;
            line-height: 21px;
          }

          .dis {
            font-size: 11px;
            font-weight: 400;
            color: #7B7B7B;
            line-height: 16px;
          }
        }
      }

      .logo {
        img {
          width: 44px;
          object-fit: cover;

          @media screen and(max-width:768px) {
            width: 30px
          }
        }
      }
    }

    .body {
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      .good {
        width: 478px;
        height: 480px;
        margin: 20px 0 30px 0;
        border-radius: 15px;
        object-fit: cover;

        @media screen and(max-width:768px) {
          width: 335px;
          height: 334px;
          margin: 10px 0;
          object-fit: cover;
        }
      }

      .name {
        font-size: 18px;
        font-weight: 500;
        color: #1E170F;
        line-height: 25px;
        font-weight: 600;
        width: 100%;

        .v-icon {
          width: 16px;
          margin: 0 0 0 6px;
        }
      }

      .user {
        font-size: 11px;
        font-weight: 400;
        color: #7B7B7B;
        line-height: 16px;
        margin: 10px 0 10px 0;
        width: 100%;

        @media screen and(max-width:768px) {
          margin: 10px 0
        }
      }

      .no-user {
        font-size: 14px;
        color: #2E2E2E;
        font-weight: 600;
      }
    }

    .footer {
      width: 100%;
      height: 110px;
      background: #F7F7F7;
      border-radius: 1px;
      padding: 0 17px 0 17px;

      @media screen and(max-width:768px) {
        height: 78px;
      }

      .left {
        p {
          font-size: 12px;
          font-weight: 400;
          color: #6F6F6F;
          line-height: 24px;

          @media screen and(max-width:768px) {
            font-size: 10px;
            line-height: 20px;
          }
        }

        img {
          width: 15px;
          height: 15px;
        }
      }

      .right {
        .qrCodeDiv {
          width: 80px;
          height: 80px;

          @media screen and(max-width:768px) {
            width: 80px;
            height: 80px;
          }

          // canvas{
          //   display: none !important;
          // }
          img {
            width: 80px;
            height: 80px;
          }
        }
      }
    }
  }

  .img {
    width: 428px;
    height: 800px;
    background: #FFFFFF;
    border-radius: 4px;
    margin: 18px auto;
    background: #FFFFFF;
    // border-radius: 4px;
    // margin: 38px auto;
    // padding: 10px 0 0 0;
    display: flex;
    justify-content: start;
    align-items: start;
    flex-direction: column;
    overflow: hidden;

    @media screen and(max-width:768px) {
      margin: 18px auto 0 auto;
      width: 295px;
      height: 600px;
      padding: 15px 0 0 0;
      // padding:10px 0 0 0;
    }

    img {
      width: 100%;
      height: auto;

      @media screen and(max-width:768px) {

        width: 295px;
        height: 550px;
      }
    }

    .remind {
      width: 100%;
      height: 30px;
      background: #F7F7F7;
      text-align: center;
      font-size: 12px;
      font-weight: 400;
      color: #404040;
      line-height: 30px;
      display: none;

      @media screen and(max-width:768px) {
        display: block;
      }
    }
  }

  .back {
    display: none;
  }

  .close {
    width: 16px;
    height: 16px;
    margin: 36px 31px 0 538px;
    cursor: pointer;

    @media screen and(max-width:768px) {
      display: none;
    }
  }

  .cancel {
    position: absolute;
    top: 0;
    right: -67px;
    width: 40px;
    height: 40px;
    z-index: 2;
    cursor: pointer;

    img {
      width: 40px;
      height: 40px;
    }

    @media screen and(max-width:768px) {
      display: none;
    }
  }

  .save {
    width: 170px;
    height: 44px;
    background: #E8721D;
    box-shadow: 0px 4px 6px 0px rgba(232, 114, 29, 0.3);
    border-radius: 22px;
    text-align: center;
    line-height: 44px;
    color: white;
    font-size: 16px;
    cursor: pointer;

    @media screen and(max-width:768px) {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/conponents/blindBoxShare/index.vue